import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NvLogoModule } from '../../../nvps-libraries/design/nv-logo/nv-logo.module';
import { NvSidebarItemModule } from 'Src/nvps-libraries/design/nv-sidebar-item/nv-sidebar-item.module';
import { NvSidebarListModule } from 'Src/nvps-libraries/design/nv-sidebar-list/nv-sidebar-list.module';
import { ShelterSideNavComponent } from './shelter-side-nav.component';

@NgModule({
  declarations: [ShelterSideNavComponent],
  imports: [CommonModule, NvLogoModule, NvSidebarListModule, NvSidebarItemModule],
  exports: [ShelterSideNavComponent],
  providers: [],
  schemas: [],
})
export class ShelterSideNavModule {}
